import Backdrop from "@mui/material/Backdrop";
import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { Loader } from "commonComponents/Loader/Loader";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";

const LoadingBackdrop = () => {
  const { loadingOnProcess } = useHookstate(MAP_GLOBAL_STATES);
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loadingOnProcess.get()}
    >
      <CenteredLoader>
        <Loader />
      </CenteredLoader>
    </Backdrop>
  );
};

export default LoadingBackdrop;
